import React from 'react';
import { useDroppable } from '@dnd-kit/core';
import { Plus } from 'lucide-react';
import { Task } from '../../types';
import { SortableTaskCard } from './SortableTaskCard';

interface KanbanColumnProps {
  id: Task['status'];
  title: string;
  color: string;
  tasks: Task[];
  onTaskClick: (task: Task) => void;
  onAddTask: () => void;
}

export function KanbanColumn({ id, title, color, tasks, onTaskClick, onAddTask }: KanbanColumnProps) {
  const { setNodeRef, isOver } = useDroppable({
    id,
    data: {
      type: 'column',
      status: id,
    },
  });

  return (
    <div
      ref={setNodeRef}
      className={`flex-shrink-0 w-72 flex flex-col rounded-lg overflow-hidden transition-colors ${
        isOver ? 'bg-primary-50 ring-2 ring-primary-200' : 'bg-gray-50'
      }`}
    >
      {/* Column header */}
      <div className="px-3 py-3 flex items-center justify-between text-white" style={{ backgroundColor: color }}>
        <div className="flex items-center gap-2 min-w-0">
          <span className="font-semibold text-sm truncate">{title}</span>
          <span className="bg-white/20 text-white text-xs px-2 py-0.5 rounded-full font-medium">
            {tasks.length}
          </span>
        </div>
        <button
          onClick={onAddTask}
          className="p-1 text-white/80 hover:text-white hover:bg-white/15 rounded transition-colors"
          title="Adicionar tarefa"
        >
          <Plus size={16} />
        </button>
      </div>

      {/* Tasks */}
      <div className="flex-1 p-3 space-y-2 min-h-[160px]">
        {tasks.map(task => (
          <SortableTaskCard key={task.id} task={task} onClick={onTaskClick} />
        ))}
        {tasks.length === 0 && (
          <div className="flex flex-col items-center justify-center h-24 text-center">
            <p className="text-xs text-gray-400">Nenhuma tarefa ainda</p>
            <button
              onClick={onAddTask}
              className="mt-2 text-xs text-primary-500 hover:text-primary-600 transition-colors"
            >
              + Adicionar tarefa
            </button>
          </div>
        )}
      </div>
    </div>
  );
}
